// AuthUtils.js
export const authMessages = {
  "auth/invalid-credential": ["Incorrect email or password.", "We couldn’t log you in."],
  "auth/user-not-found": ["No account found with this email."],
  "auth/wrong-password": ["Wrong password. Please try again."],
  "auth/email-already-in-use": ["This email is already registered."],
  "auth/weak-password": ["Password is too weak."],
  "auth/popup-closed-by-user": ["Sign-in was cancelled."],
  "auth/network-request-failed": ["Network error. Check your internet."],
  "default": ["Something went wrong. Please try again."]
};

export const getRandomMessage = (code) => {
  const messages = authMessages[code] || authMessages.default;
  return messages[Math.floor(Math.random() * messages.length)];
};

export const handleVSCodeRedirect = async (auth) => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('source') === 'vscode' && auth.currentUser) {
    const token = await auth.currentUser.getIdToken();
    const uid = auth.currentUser.uid;
    const mail = auth.currentUser.email || '';
    window.location.href = `vscode://ozia.ozia-extension/auth?uid=${uid}&email=${encodeURIComponent(mail)}&token=${token}`;
  }
};